module.exports = "<div class=modal-header> <h3 class=modal-title>Code Generator Error</h3> </div> <div class=modal-body> <p>{{data.message}}</p> <p>Details:</p> <json-formatter json=data class=json-formatter-dark></json-formatter> </div> <div class=modal-footer> <button class=\"btn btn-warning\" ng-click=cancel()>OK</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./templates/code-gen-error-modal.html
// module id = 392
// module chunks = 0